import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentFile } from '../store/selectors';
import { getImportSummary } from '../store/run_records_selectors';

export function ImportSummary({ currentFile, importSummary }) {
  const renderPanel = (title, count, className) => {
    return (
      <div className={`${className}`}>
        <div className="p-5">
          <div className="summary-count">{count}</div>
          <div className="summary-label">{title}</div>
        </div>
      </div>
    );
  };

  const renderSummaryPanels = () => {
    const { created, failed, skipped, updated } = importSummary;

    return (
      <div className="summary-cards">
        {renderPanel('Created', created, 'created-card')}
        {renderPanel('Updated', updated, 'updated-card')}
        {renderPanel('Failed', failed, 'failed-card')}
        {renderPanel('Skipped', skipped, 'skipped-card')}
      </div>
    );
  };

  return (
    <div>
      <p className="mt-4">
        <strong>{currentFile.completedRecords}</strong>
        &nbsp;records imported to&nbsp;
        <strong>{currentFile.mapperLabel}</strong>
      </p>
      <div>
        {renderSummaryPanels()}
      </div>
    </div>
  );
}

ImportSummary.propTypes = {
  currentFile: PropTypes.object.isRequired,
  importSummary: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  currentFile: getCurrentFile(state),
  importSummary: getImportSummary(state)
});

export default connect(mapStateToProps, null)(ImportSummary);
